import { useMediaQuery } from "@mantine/hooks";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { AddJob } from "./addModal";
import { loadJobs } from "./loadData";
import { jobsHeader } from "./tableHeaders";

const Jobs = ({}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);
  const [jobs, setJobs] = useState([]);

  const [opened, setOpened] = useState(false);
  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [update, setUpdate] = useState(false);

  useEffect(() => {
    loadJobs(setLoading).then(setJobs);
  }, [location.pathname, update]);

  console.log("haha", deleteData);
  const matches1200 = useMediaQuery("(min-width: 1200px)");
  return (
    <AdminPage title="Jobs">
      <ModalWrapper
        size={matches1200 ? "60%" : "xl"}
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Job Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData.categoryName}
            description={viewModalData.categoryDescription}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
            allData={viewModalData}
          />
        }
      />
      <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete Job"}
        InternalComponent={
          <DeleteModalContent
            route={`job/deleteJob/${deleteData._id}`}
            type={"Job"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      />

      <AddJob
        opened={opened}
        setOpened={setOpened}
        setUpdate={setUpdate}
        editData={editData}
        setEditData={setEditData}
        setEditModalState={setEditModalState}
        editModalState={editModalState}
        setLoading={setLoading}
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={jobsHeader}
          rowData={jobs}
          showAddButton={true}
          setOpened={setOpened}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(Jobs);
